var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4814 15.4814V2.51848H2.51848V15.4814H15.4814ZM15.4814 0.666626C15.9726 0.666626 16.4436 0.861731 16.7909 1.20902C17.1382 1.55631 17.3333 2.02734 17.3333 2.51848V15.4814C17.3333 15.9726 17.1382 16.4436 16.7909 16.7909C16.4436 17.1382 15.9726 17.3333 15.4814 17.3333H2.51848C2.02734 17.3333 1.55631 17.1382 1.20902 16.7909C0.861731 16.4436 0.666626 15.9726 0.666626 15.4814V2.51848C0.666626 2.02734 0.861731 1.55631 1.20902 1.20902C1.55631 0.861731 2.02734 0.666626 2.51848 0.666626H15.4814Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88881 13.1666L4.83325 10.0784L6.14278 8.75486L7.88881 10.5196L12.6904 5.66663L13.9999 6.99016L7.88881 13.1666Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.d3f7cd14.svg";
export { ForwardRef as ReactComponent };